/**
 * Who can use the multi-model comparison surface while it is being evaluated.
 *
 * This gate hides new controls — the model picker, "+ Model", the activity rail and
 * the /assistant page. It does not take the assistant away: everyone else keeps the
 * single-model chat exactly as it works today.
 *
 * A hardcoded list is deliberate. This is a short-lived evaluation with six named
 * participants, and a list in the client is honest about being a UI convenience
 * rather than a security boundary — the worker authenticates every request on its
 * own, and nothing here protects data.
 */
export const ASSISTANT_TESTERS = [
  "rondie@mavenmm.com",
  "dave@mavenmm.com",
  "chang@mavenmm.com",
  "adam@mavenmm.com",
  "kris@mavenmm.com",
  "chris@mavenmm.com",
] as const;

const ALLOWED = new Set<string>(ASSISTANT_TESTERS);

export function canUseModelComparison(email: string | null | undefined): boolean {
  if (!email) return false;
  // Exact match on the normalised address — never a substring or suffix test, which
  // would admit chris.smith@mavenmm.com or rondie@mavenmm.com.evil.com.
  return ALLOWED.has(email.trim().toLowerCase());
}
